export default __webpack_public_path__ + "static/media/ATK_Logo.3fc92186.svg";